import * as STD from '@emersya/mpa-std-lib';

import CM                                  from '@emersya/mpa-components-manager-lib';
import { Block, InputBool }                from '@emersya/mpa-components-lib';
import * as BasketNS                       from '@emersya/mpa-basket-lib';
import ViewerComponent, { NS as ViewerNS } from '../../../viewer/Viewer/Viewer';
import manifestXMLSource                   from './StandingHighSign.xml';
import './StandingHighSign.scss';

export interface IStandingHighSignComponentConfiguration extends Block.Configuration {
	text : STD.translationsManager.TranslationMapping;
	forceBackgroundColor? : string | null;
	textGraphic : STD.translationsManager.TranslationMapping;
};

export class StandingHighSignComponent extends Block.Component {
	static override initialize() {
		super.initialize();
	};

	readonly plannerCategory! : ViewerComponent.ProductCategory;
	viewerNode : ViewerComponent.ProductInstance | null = null;
	firstInstance : boolean = true;

	getWDH() {
		const p = app.currentProduct;
		if (!p) {
			this.component_throwUserError('');
		}
		const dpart = p.getPart([ 'dimensions' ]);
		return {
			width :  Number.parseFloat(dpart.getPart([ 'width' ])?.reference?.value || <string> <any> 1),
			depth :  Number.parseFloat(dpart.getPart([ 'depth' ])?.reference?.value || <string> <any> 1),
			height : Number.parseFloat(dpart.getPart([ 'height' ])?.reference?.value || <string> <any> 1)
		};
	};

	async reset() {
		if (!app.basket) {
			this.component_throwLibraryError('');
		}
		if (!app.basket.basket.currentProduct) {
			this.component_throwLibraryError('');
		}
		if (this.viewerNode) {
			await this.viewerNode.delete();
			this.viewerNode = null;
		}
		this.updateBannerNodeShowCustomImageEditor();
		const inputBool = <InputBool.Component> this.component_find('@:field:content.options');
		if (!inputBool) {
			throw STD.errors.user('Missing input bool in content');
		}
		// if (inputBool.value) {
		// 	await inputBool.updateValue(false);
		// }
		const highSignPart = app.basket.basket.currentProduct.parts.find(x => x.id === 'highSign');
		if (highSignPart) {
			await app.basket.basket.currentProduct.getPart([ 'highSign' ]).remove();
		}
	};

	async remove(){
		if (!app.basket) {
			this.component_throwLibraryError('');
		}
		if (!app.basket.basket.currentProduct) {
			this.component_throwLibraryError('');
		}
		if (this.viewerNode) {
			await this.viewerNode.delete();
			this.viewerNode = null;
		}
		this.updateBannerNodeShowCustomImageEditor();
		const highSignPart = app.basket.basket.currentProduct.parts.find(x => x.id === 'highSign');
		if (highSignPart) {
			await app.basket.basket.currentProduct.getPart([ 'highSign' ]).remove();
		}
	};

	async onProductChange_before(){
		await this.remove();
		this.firstInstance = true;
	};

	async onProductChange_after(){
		const viewerGraphic = <ViewerGraphicsNS.Component> this.component_find('@:graphic');
		await viewerGraphic.reset();
	};

	private computeMatrix(side : string) {
		const product = app.currentProduct;
		if (!product) {
			throw STD.errors.user('No current product available in arch!');
		}
		const layoutPart = product.getPart([ 'layout' ]);
		if (!layoutPart) {
			throw STD.errors.user('No part layout available in arch');
		}
		const layoutCurrentOption = layoutPart.currentOption;
		if (!layoutCurrentOption) {
			throw STD.errors.user('No current option in layout part in arch');
		}
		const layoutId = layoutCurrentOption.id;
		if (!app.basket) {
			this.component_throwLibraryError('');
		}
		if (!app.basket.basket.currentProduct) {
			this.component_throwLibraryError('');
		}
		const highSignPart = app.basket.basket.currentProduct.getPart([ 'highSign' ]);
		if (side === 'prestige') {
			const highSignPrestige = app.component_configuration.productsComponents.find(x => x.type ===
				'highSign' &&
				x.products.includes('prestige'));
			if (!highSignPrestige) {
				throw STD.errors.user('Missing prestige high sign in component sheet');
			}
			highSignPart.reference = new BasketNS.Reference(highSignPrestige.SKU);
			if (layoutId === 'shape-no-wall' || layoutId === 'shape-back' || layoutId === 'shape-left-back-right') {
				return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ 1, 1, 1 ], 0));
			} else if (layoutId === 'shape-back-right') {
				return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ 1, 1, 1 ], 315));
			} else if (layoutId === 'shape-back-left') {
				return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ 1, 1, 1 ], 45));
			} else {
				throw STD.errors.user('Unknown layout name in high sign');
			}
		} else {
			const wdh = this.getWDH();
			const x = wdh.width;
			const z = wdh.depth;
			const surface = x * z;
			if (surface > 25) {
				if (side === 'large') {
					const highSignBusiness = app.component_configuration.productsComponents.find(x => x.type ===
						'highSign' &&
						x.SKU.endsWith('large'));
					if (!highSignBusiness) {
						throw STD.errors.user('Missing business high sign in component sheet');
					}
					highSignPart.reference = new BasketNS.Reference(highSignBusiness.SKU);
					return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ 1, 1, 1 ], 0));
				} else {
					return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ 0, 0, 0 ], 0));
				}
			} else if (surface > 11) {
				if (side === 'medium') {
					const highSignBusiness = app.component_configuration.productsComponents.find(x => x.type ===
						'highSign' &&
						x.SKU.endsWith('medium'));
					if (!highSignBusiness) {
						throw STD.errors.user('Missing business high sign in component sheet');
					}
					highSignPart.reference = new BasketNS.Reference(highSignBusiness.SKU);
					if (layoutId === 'shape-no-wall' || layoutId === 'shape-back' || layoutId === 'shape-left-back-right') {
						return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ 1, 1, 1 ], 0));
					} else if (layoutId === 'shape-back-right') {
						return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ 1, 1, 1 ], 315));
					} else if (layoutId === 'shape-back-left') {
						return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ 1, 1, 1 ], 45));
					} else {
						throw STD.errors.user('Unknown layout name in high sign');
					}
				} else {
					return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ 0, 0, 0 ], 0));
				}
			} else if (surface > 8) {
				if (side === 'small') {
					const highSignBusiness = app.component_configuration.productsComponents.find(x => x.type ===
						'highSign' &&
						x.SKU.endsWith('small'));
					if (!highSignBusiness) {
						throw STD.errors.user('Missing business high sign in component sheet');
					}
					highSignPart.reference = new BasketNS.Reference(highSignBusiness.SKU);
					if (layoutId === 'shape-no-wall' || layoutId === 'shape-back' || layoutId === 'shape-left-back-right') {
						return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ 1, 1, 1 ], 0));
					} else if (layoutId === 'shape-back-right') {
						return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ 1, 1, 1 ], 315));
					} else if (layoutId === 'shape-back-left') {
						return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ 1, 1, 1 ], 45));
					} else {
						throw STD.errors.user('Unknown layout name in high sign');
					}
				} else {
					return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ 0, 0, 0 ], 0));
				}
			} else {
				return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ 0, 0, 0 ], 0));
			}
		}
	}

 	updateBannerNodeShowCustomImageEditor() {
		if (this.viewerNode && this.viewerNode.metadata.customImages && this.viewerNode.metadata.customImages[ 0 ]) {
			this.viewerNode.metadata.customImages[ 0 ].showEditor = false;
		}
	};

	async updateWithoutReset(){
		await app.viewer.freezeRendering({ keepCount : true });
		if (app.isReloading) {
			if (!this.viewerNode) {
				await this.insert();
			}
		} else {
			if (this.viewerNode) {
				await this.remove();
			}
			await this.insert();
		}
		await app.viewer.unfreezeRendering({ keepCount : true });
	}

	async update() {
		const inputBool = <InputBool.Component> this.component_find('@:field:content.options');
		if(!inputBool){
			this.component_throwUserError('');
		}
		if(!inputBool.value && this.firstInstance){
			inputBool.updateValue(true);
		}else if(!inputBool.value){
			return;
		}
		this.firstInstance = false;
		await app.viewer.freezeRendering({ keepCount : true });
		if (app.isReloading) {
			if (!this.viewerNode) {
				await this.insert();
			}
		} else {
			if (this.viewerNode) {
				await this.reset();
			}
			await this.insert();
		}
		await app.viewer.unfreezeRendering({ keepCount : true });
	};

	async updateWhenLayoutChanges(){
		const product = app.currentProduct;
		if (!product) {
			this.component_throwUserError('');
		}
		if(product.id === 'siae' || product.id === 'confort'){
			return;
		}
		if(!this.viewerNode){
			this.update();
			return;
		}
		const computeSmall = this.computeMatrix('small');
		const computeMedium = this.computeMatrix('medium');
		const computeLarge = this.computeMatrix('large');
		if(product.id === 'prestige'){
			await app.viewer.batch([
				[
					'setProductNodesInstancesMatrices', [
					{
						localId : this.viewerNode.localId,
						matrix :  this.computeMatrix('prestige')
					}
				]
				]
			]);
		}else if(product.id === 'business'){
			if(!this.isEqual(computeSmall, ViewerNS.Component.mtx([0,0,0],[0,0,0],0))){
				await app.viewer.batch([
					[
						'setProductNodesInstancesMatrices', [
						{
							localId : this.viewerNode.localId,
							matrix :  computeSmall
						}
					]
					]
				]);
			}else if(!this.isEqual(computeMedium, ViewerNS.Component.mtx([0,0,0],[0,0,0],0))){
				await app.viewer.batch([
					[
						'setProductNodesInstancesMatrices', [
						{
							localId : this.viewerNode.localId,
							matrix :  computeMedium
						}
					]
					]
				]);
			}else if(!this.isEqual(computeLarge, ViewerNS.Component.mtx([0,0,0],[0,0,0],0))){
				await app.viewer.batch([
					[
						'setProductNodesInstancesMatrices', [
						{
							localId : this.viewerNode.localId,
							matrix :  computeLarge
						}
					]
					]
				]);
			}
		}
	};

	async insert() {
		// insert nodes
		const product = app.currentProduct;
		if (this.viewerNode || !product || !app.viewer.planner) {
			this.component_throwUserError('');
		}
		if (product.id === 'confort' || product.id === 'siae') {
			return;
		}
		const part = product.createPart({
			id :        'highSign',
			title :     'High-Sign',
			reference : null,
			metaData :  null,
			parts :     [],
			options :   []
		});
		await part.initialize();
		const category = app.viewer.categories.find(x => x.name === 'highSign');
		if (!category) {
			this.component_throwLibraryError('');
		}
		if (app.isReloading) {
			const instances = Array.from(app.viewer.safe.value.productInstances);
			const node = instances.find(x => x.product.category === category);
			if (!node) {
				return;
			}
			this.viewerNode = node;
			await (<ViewerGraphicsNS.Component> this.component_find('@:graphic')).updateValue((<any> node).metadata.customImages[ 0 ]);
			this.viewerNode.setName('highSign');
			return;
		}
		if(product.id === 'prestige'){
			const highSignProductSchema = this.plannerCategory.products.find(x => x.SKU === '@highSign-' + product.id);
			if (!highSignProductSchema) {
				this.component_throwLibraryError('');
			}
			this.viewerNode = await highSignProductSchema.instantiate({
				rootLocalId : app.viewer.globalLocalId,
				appendType : 'insert',
				basketPart : [],
				basketUseDynamicTitleBinding : true,
				metadata : {
					id :           this.id,
					customImages : [
						{
							enabled :   false,
							leftRight : 0,
							upDown :    0,
							resize :    1,
							rotate :    0,
							image :     null
						}
					]
				}
			});
			this.viewerNode.setName('highSign');
			await app.viewer.batch([
				[
					'setProductNodesInstancesMatrices', [
					{
						localId : this.viewerNode.localId,
						matrix :  this.computeMatrix('prestige')
					}
				]
				]
			]);
		}else if(product.id === 'business'){
			const computeSmall = this.computeMatrix('small');
			const computeMedium = this.computeMatrix('medium');
			const computeLarge = this.computeMatrix('large');
			if(!this.isEqual(computeSmall, ViewerNS.Component.mtx([0,0,0],[0,0,0],0))){
				const highSignProductSchema = this.plannerCategory.products.find(x => x.SKU === 'high-sign-business-small');
				if (!highSignProductSchema) {
					this.component_throwLibraryError('');
				}
				this.viewerNode = await highSignProductSchema.instantiate({
					rootLocalId : app.viewer.globalLocalId,
					appendType : 'insert',
					basketPart : [],
					basketUseDynamicTitleBinding : true,
					metadata : {
						id :           this.id,
						customImages : [
							{
								enabled :   false,
								leftRight : 0,
								upDown :    0,
								resize :    1,
								rotate :    0,
								image :     null
							}
						]
					}
				});
				this.viewerNode.setName('highSign');
				await app.viewer.batch([
					[
						'setProductNodesInstancesMatrices', [
						{
							localId : this.viewerNode.localId,
							matrix :  this.computeMatrix('small')
						}
					]
					]
				]);
			}else if(!this.isEqual(computeMedium, ViewerNS.Component.mtx([0,0,0],[0,0,0],0))){
				const highSignProductSchema = this.plannerCategory.products.find(x => x.SKU === 'high-sign-business-medium');
				if (!highSignProductSchema) {
					this.component_throwLibraryError('');
				}
				this.viewerNode = await highSignProductSchema.instantiate({
					rootLocalId : app.viewer.globalLocalId,
					appendType : 'insert',
					basketPart : [],
					basketUseDynamicTitleBinding : true,
					metadata : {
						id :           this.id,
						customImages : [
							{
								enabled :   false,
								leftRight : 0,
								upDown :    0,
								resize :    1,
								rotate :    0,
								image :     null
							}
						]
					}
				});
				this.viewerNode.setName('highSign');
				await app.viewer.batch([
					[
						'setProductNodesInstancesMatrices', [
						{
							localId : this.viewerNode.localId,
							matrix :  this.computeMatrix('medium')
						}
					]
					]
				]);
			}else if(!this.isEqual(computeLarge, ViewerNS.Component.mtx([0,0,0],[0,0,0],0))){
				const highSignProductSchema = this.plannerCategory.products.find(x => x.SKU === 'high-sign-business-large');
				if (!highSignProductSchema) {
					this.component_throwLibraryError('');
				}
				this.viewerNode = await highSignProductSchema.instantiate({
					rootLocalId : app.viewer.globalLocalId,
					appendType : 'insert',
					basketPart : [],
					basketUseDynamicTitleBinding : true,
					metadata : {
						id :           this.id,
						customImages : [
							{
								enabled :   false,
								leftRight : 0,
								upDown :    0,
								resize :    1,
								rotate :    0,
								image :     null
							}
						]
					}
				});
				this.viewerNode.setName('highSign');
				await app.viewer.batch([
					[
						'setProductNodesInstancesMatrices', [
						{
							localId : this.viewerNode.localId,
							matrix :  this.computeMatrix('large')
						}
					]
					]
				]);
			}
		}
		const ciData = this.viewerNode?.metadata?.customImages?.[ 0 ];
		if (ciData) {
			await (<ViewerGraphicsNS.Component> this.component_find('@:graphic')).updateValue(<any> ciData);
		}
		const inputBool = <InputBool.Component> this.component_find('@:field:content.options');
		if (!inputBool) {
			throw STD.errors.user('Missing input bool in content');
		}
		if (!inputBool.value) {
			await inputBool.updateValue(true);
		}
	};

	isEqual(tableau1 : ViewerComponent.TMatrix , tableau2 : ViewerComponent.TMatrix ) {
		if (tableau1.length !== tableau2.length) return false;

		return tableau1.every((value, index) => value === tableau2[index]);
	};

	async onValueUpdated(ev : STD.events.Event<any, CM.Component<any, any>>) {
		// await super.onValueUpdated(ev);
		if (ev.details.isDefaultValue) {
			return;
		}
		if (!app.basket || !app.basket.basket.currentProduct) {
			this.component_throwLibraryError('');
		}
		;
		const graphicComponent = <InputBool.Component> this.component_find('@:graphic');
		await app.transaction(async () => {
			if (ev.details.newValue) {
				await graphicComponent.component_enable();
				await this.updateWithoutReset();
			} else {
				const graphicInput = <InputBool.Component> this.component_find('@:graphic:header.enable');
				if (graphicInput.value) {
					await graphicInput.updateValue(false);
				}
				await graphicComponent.component_disable();
				await this.remove();
			}
		});
	};

	override async component_initialize() {
		await this.component_find('@:field:content').component_instantiateOuterChild({
			type :          'input-bool',
			isSlot :        false,
			declaredSlot :  null,
			id :            'options',
			slot :          null,
			tree :          this.component_tree,
			parentNode :    null,
			configuration : <InputBool.Configuration> {
				type :            'yesno',
				defaultValue :    true,
				'@translations' : {
					checked :   {
						'en' : 'Yes',
						'fr' : 'Oui'
					},
					unchecked : {
						'en' : 'No',
						'fr' : 'Non'
					}
				}
			}
		});
		await super.component_initialize();
		if (!app.basket) {
			this.component_throwLibraryError('');
		}
	};

	getConfiguratorMenu() {
		return this;
	};

	override async component_start(ev : STD.events.Event<any, any>) {
		await super.component_start(ev);
		const planner = app.viewer.planner;
		if (!planner) {
			this.component_throwUserError('');
		}
		const categoryDescriptor : ViewerComponent.ProductCategory.IDescriptor & {
			products : NonNullable<ViewerComponent.ProductCategory.IDescriptor['products']>;
		} = {
			name :        'highSign',
			menuActions : {
				edit :      true,
				delete :    false,
				rotate :    false,
				duplicate : false
			},
			products :    []
		};
		const defaultExtension = (localId : string, key : string) => {
			let size = '';
			let width = 1;
			let height = 1;
			if(key === 'small'){
				size = '_petite';
				width = 2;
				height = 1.2;
			}else if(key === 'medium'){
				size = '_petite';
				width = 2;
				height = 1.2;
			}else{
				width = 2;
				height = 1.2;
			}
			return <ViewerComponent.IProductExtension> {
				quantity :     null,
				configuratorGet : CM.PropertyOperation.CallOperation.create({
					type :          'call',
					componentPath : this.component_getPath(),
					propertyPath :  'getConfiguratorMenu',
					parameters :    []
				}),
				customImages : [
					{
						id :       'customImg',
						title :    { en : 'Add logo', fr : 'Ajouter un logo' },
						width :    width,
						height :   height,
						mesh :     'custom_logo_enseigne_haute'+size,
						material : {
							name :          'custom_logo_enseigne_haute',
							configuration : {
								enabled :  'custom_logo_enseigne_haute',
								disabled : 'off'
							}
						},
						getLocalId() {
							return <number> this.idMapping[localId];
						},
						pricingInfo :       null,
						volumeComputation : null
					}
				],
			}
		};
		if (app.component_configuration.products.find(x => x.SKU === 'business')) {
			const highSignBusinessComponent = app.component_configuration.productsComponents.filter(x => x.type ===
				'highSign' &&
				x.products.includes('business')).reduce((a, c) => {
				(<any> a)[ c.SKU.replace('high-sign-business-', '') ] = c;
				return a;
			}, <Record<'small' | 'medium' | 'large', typeof app.component_configuration.productsComponents[0]>> {});
			if (!highSignBusinessComponent.small || !highSignBusinessComponent.medium || !highSignBusinessComponent.large) {
				throw STD.errors.user('Missing a business high sign');
			}
			const createProduct = (
				viewerComponentSKU : string,
				viewerProjectCode : string,
				localId : string,
				key : string
			) => {
				app.viewer.productsExtensionById[ `${ localId }` ] = defaultExtension(localId, key);
				return {
					SKU :   `${ localId }`,
					nodes : [
						{
							SKU :                         viewerComponentSKU,
							projectCode :                 viewerProjectCode,
							localId :                     localId,
							parentLocalId :               'root',
							snappable :                   false,
							fixedPositionSetIds :         null,
							draggable :                   false,
							doNotListAsProductComponent : true,
							tracked :                     true,
							matrix :                      app.viewer.mtx(
								[ 0, 0, 0 ],
								[ 1, 1, 1 ],
								0
							)
						}
					]
				};
			};
			for(const [key,value] of Object.entries(highSignBusinessComponent)){
				if(!value.viewerComponentSKU || !value.viewerProjectCode || !value.SKU){
					this.component_throwUserError('');
				}
				void key;
				categoryDescriptor.products.push(createProduct(value.viewerComponentSKU, value.viewerProjectCode, value.SKU, key))
			}
			// categoryDescriptor.products.push({
			// 	SKU :   '@highSign-business',
			// 	nodes : [
			// 		app.viewer.createEmptyNodeDescriptor('global', 'root', ViewerNS.Component.mtx([0,0,0], [1,1,1], 0)),
			// 		{
			// 			SKU :                         <string> highSignBusinessComponent.small.viewerComponentSKU,
			// 			projectCode :                 <string> highSignBusinessComponent.small.viewerProjectCode,
			// 			localId :                     'highSignBusinessSmall',
			// 			parentLocalId :               'global',
			// 			snappable :                   false,
			// 			fixedPositionSetIds :         null,
			// 			draggable :                   false,
			// 			doNotListAsProductComponent : true,
			// 			matrix :                      app.viewer.mtx(
			// 				[ 0, 0, 0 ],
			// 				[ 0, 0, 0 ],
			// 				0
			// 			)
			// 		},
			// 		{
			// 			SKU :                         <string> highSignBusinessComponent.medium.viewerComponentSKU,
			// 			projectCode :                 <string> highSignBusinessComponent.medium.viewerProjectCode,
			// 			localId :                     'highSignBusinessMedium',
			// 			parentLocalId :               'global',
			// 			snappable :                   false,
			// 			fixedPositionSetIds :         null,
			// 			draggable :                   false,
			// 			doNotListAsProductComponent : true,
			// 			matrix :                      app.viewer.mtx(
			// 				[ 0, 0, 0 ],
			// 				[ 0, 0, 0 ],
			// 				0
			// 			)
			// 		},
			// 		{
			// 			SKU :                         <string> highSignBusinessComponent.large.viewerComponentSKU,
			// 			projectCode :                 <string> highSignBusinessComponent.large.viewerProjectCode,
			// 			localId :                     'highSignBusinessLarge',
			// 			parentLocalId :               'global',
			// 			snappable :                   false,
			// 			fixedPositionSetIds :         null,
			// 			draggable :                   false,
			// 			doNotListAsProductComponent : true,
			// 			matrix :                      app.viewer.mtx(
			// 				[ 0, 0, 0 ],
			// 				[ 0, 0, 0 ],
			// 				0
			// 			)
			// 		}
			// 	]
			// });
		}
		if (app.component_configuration.products.find(x => x.SKU === 'prestige')) {
			const highSignPrestigeComponent = app.component_configuration.productsComponents.find(x => x.type ===
				'highSign' &&
				x.products.includes('prestige'));
			if (!highSignPrestigeComponent) {
				throw STD.errors.user('Missing high sign component');
			}
			app.viewer.productsExtensionById[ '@highSign-prestige' ] = {
				quantity :     null,
				configuratorGet : CM.PropertyOperation.CallOperation.create({
					type :          'call',
					componentPath : this.component_getPath(),
					propertyPath :  'getConfiguratorMenu',
					parameters :    []
				}),
				customImages : [
					{
						id :                '@highSign-prestige',
						title :             { en : 'Add logo', fr : 'Ajouter un logo' },
						width :             1.46,
						height :            1.46,
						mesh :              'ENSEIGNE_HAUTE_CERCLE.001.001',
						material :          {
							name :          'custom_logo_enseigne_haute',
							configuration : {
								enabled :  'custom',
								disabled : 'none'
							}
						},
						pricingInfo :       null,
						volumeComputation : {
							boundTo :          'surface-image-sqm',
							roundingStrategy : 'none'
						}
					}
				]
			};
			categoryDescriptor.products.push({
				SKU :   '@highSign-prestige',
				nodes : [
					{
						SKU :                         <string> highSignPrestigeComponent.viewerComponentSKU,
						projectCode :                 <string> highSignPrestigeComponent.viewerProjectCode,
						localId :                     'highSignPrestige',
						parentLocalId :               'root',
						snappable :                   false,
						fixedPositionSetIds :         null,
						draggable :                   false,
						doNotListAsProductComponent : true,
						tracked : 					  true,
						matrix :                      app.viewer.mtx(
							[ 0, 0, 0 ],
							[ 0, 0, 0 ],
							0
						)
					}
				]
			});
		}
		(<any> this).plannerCategory = app.viewer.createCategory(categoryDescriptor);
	};

	constructor(
		descriptor : ConstructorParameters<typeof CM.Component>[0],
		configuration : IStandingHighSignComponentConfiguration
	)
	{
		configuration[ '@innerConfigurations' ] = {
			field : {
				'@innerConfigurations' : {
					header : {
						'@innerConfigurations' : {
							label : {
								'@translations' : {
									text : configuration.text
								}
							}
						}
					}
				}
			},
			graphic :    <Partial<ViewerGraphicsNS.Configuration>> {
				forceBackgroundColor :   configuration.forceBackgroundColor,
				'@innerConfigurations' : {
					header : {
						'@innerConfigurations' : {
							title : {
								'@translations' : {
									text : configuration.textGraphic
								}
							}
						}
					}
				}
			}
		};
		super(descriptor, configuration);
		this.component_DOM = <HTMLDivElement> STD.DOM.factory({
			tag : 'div'
		});

	};
};
export namespace NS {
	export const Component = StandingHighSignComponent;
	export type Component = StandingHighSignComponent;
	export type Configuration = IStandingHighSignComponentConfiguration;
}

import { NS as ViewerGraphicsNS }        from '../../../viewer/Graphics/ViewerGraphics';

CM.declare({
	id :       'standing-highSign',
	type :     StandingHighSignComponent,
	manifest : manifestXMLSource
});
